import * as e from "react";
import s from "../lib/IconBase.es.js";
import r from "../defs/CassetteTape.es.js";
const t = e.forwardRef((a, o) => /* @__PURE__ */ e.createElement(s, { ref: o, ...a, weights: r }));
t.displayName = "CassetteTapeIcon";
const c = t;
export {
  c as CassetteTape,
  t as CassetteTapeIcon
};
